/* eslint-disable */ /* THIS FILE HAS BEEN GENERATED. DO NOT EDIT IT. */ import { jsx as _jsx } from "react/jsx-runtime";
import { createIcon } from '../';
// prettier-ignore
const HeartFilledIcon = createIcon({
    displayName: 'HeartFilledIcon',
    viewBox: '0 0 24 24',
    pathSmall: [
        /*#__PURE__*/ _jsx("path", {
            d: "M19.963 8.49c-.125-.942-.582-1.73-1.32-2.282a3.553 3.553 0 0 0-2.85-.694c-.756.133-1.472.475-2.115.928A8.405 8.405 0 0 0 12 8.036a8.405 8.405 0 0 0-1.678-1.594c-.643-.453-1.36-.795-2.115-.928a3.553 3.553 0 0 0-2.85.694c-.738.551-1.195 1.34-1.32 2.282-.258 1.947.88 4.185 2.034 5.628a16.74 16.74 0 0 0 2.375 2.437 12.87 12.87 0 0 0 3.034 1.896c.161.071.348.095.52.095.172 0 .359-.024.52-.095a12.957 12.957 0 0 0 3.154-1.997 16.84 16.84 0 0 0 2.255-2.336c1.154-1.443 2.292-3.681 2.034-5.628Z"
        })
    ],
    pathMedium: [
        /*#__PURE__*/ _jsx("path", {
            d: "M22.95 7.174c-.172-1.295-.8-2.38-1.816-3.138-1.143-.875-2.493-1.205-3.919-.954-1.039.183-2.023.653-2.907 1.275A11.558 11.558 0 0 0 12 6.55a11.559 11.559 0 0 0-2.308-2.193c-.884-.622-1.868-1.092-2.907-1.275-1.426-.251-2.777.079-3.919.954-1.015.758-1.644 1.843-1.815 3.138-.355 2.677 1.21 5.754 2.797 7.738a23.011 23.011 0 0 0 3.266 3.351c1.266 1.05 2.658 1.944 4.172 2.608.22.097.477.129.714.129s.493-.032.714-.13c1.58-.692 3.028-1.637 4.338-2.746a23.15 23.15 0 0 0 3.1-3.211c1.587-1.985 3.152-5.062 2.797-7.739Z"
        })
    ]
});
HeartFilledIcon.defaultProps = {
    fill: 'currentColor',
    boxSize: '24px',
    display: 'block',
    ['data-testid']: 'HeartFilledIcon'
};
export { HeartFilledIcon };

//# sourceMappingURL=heart_filled.js.map